// Catalog house names the typed-query lock can recognize.
// Normalized the same way a search query is. Ordinary bottle words that are
// also houses are excluded in collectionEntryMatch.js, not here.
export const CATALOG_HOUSE_NAMES = Object.freeze([
  "27 87",
  "4711",
  "aaron terence hughes",
  "abel",
  "abercrombie fitch",
  "acqua di parma",
  "adopt paris",
  "aerin",
  "aerin lauder",
  "affinessence",
  "afnan",
  "ahmed al maghribi",
  "ahuja",
  "ajmal",
  "akro",
  "al haramain",
  "al rehab",
  "al wataniah",
  "alexandria fragrances",
  "alt fragrances",
  "alt innsbruck",
  "amaran",
  "amoroso",
  "amouage",
  "amouroud",
  "anfas",
  "anonim parfum",
  "antonio banderas",
  "antonio gardoni",
  "aoud immortals",
  "aqua velva",
  "arabian oud",
  "arabiyat prestige",
  "aramis",
  "ard al zaafaran",
  "areej le dore",
  "argos fragrances",
  "ariana grande",
  "armaf",
  "aroma concepts",
  "aromatix x french avenue",
  "asdaaf",
  "atelier cologne",
  "atkinsons",
  "atlantis",
  "atralia",
  "attar collection",
  "aura fragrances",
  "aurora scents",
  "azonto",
  "azzaro",
  "baldessarini",
  "balenciaga",
  "balmain",
  "banana republic",
  "baruti",
  "bath body works",
  "bdk parfums",
  "beaufort london",
  "bellavita",
  "bellavita luxury",
  "bentley",
  "better world fragrance house",
  "beyonce",
  "bharara",
  "bianco latte",
  "billie eilish",
  "birkholz",
  "boadicea the victorious",
  "bogart",
  "bohoboco",
  "boka",
  "bond no 9",
  "born to stand out",
  "borouj",
  "bortnikoff",
  "bottega veneta",
  "boucheron",
  "bourjois",
  "boy smells",
  "brioni",
  "britney spears",
  "brut",
  "bujairami",
  "burberry",
  "bvlgari",
  "byredo",
  "cacharel",
  "calvin klein",
  "caneza",
  "carolina herrera",
  "caron",
  "carthusia",
  "cartier",
  "castle forbes",
  "chanel",
  "chaps",
  "chateau les parfums",
  "chloe",
  "choix",
  "chopard",
  "cire trudon",
  "city rhythm",
  "clean",
  "clinique",
  "clive christian",
  "coach",
  "cologne butter",
  "comme des garcons",
  "commodity",
  "costume national",
  "coty",
  "couture",
  "creed",
  "cupid",
  "czech speake",
  "d orsay",
  "d r harris",
  "d s durga",
  "dana",
  "david beckham",
  "davidoff",
  "day three",
  "day three fragrances",
  "desmirage",
  "dior",
  "diptyque",
  "dkny",
  "dolce gabbana",
  "dossier",
  "dries van noten",
  "dsquared2",
  "dumont",
  "dumont paris",
  "dunhill",
  "eight bob",
  "electimuss",
  "elie saab",
  "elixir s",
  "elizabeth arden",
  "elizabeth taylor",
  "ellis brooklyn",
  "elyon dubai",
  "embarouge",
  "emporio armani",
  "ensar oud",
  "ermenegildo zegna",
  "escentric molecules",
  "essential parfums",
  "estee lauder",
  "etat libre d orange",
  "etro",
  "ex nihilo",
  "faan",
  "fenty",
  "filippo sorcinelli",
  "florida water",
  "floris",
  "forvr mood",
  "fragrance one",
  "fragrance story",
  "fragrance world",
  "francesca bianchi",
  "frederic malle",
  "french avenue",
  "fresh",
  "fueguia 1833",
  "fugazzi",
  "fulton roark",
  "galatea",
  "galleria parfums",
  "geo f trumper",
  "geoffrey beene",
  "giardini di toscana",
  "giorgio armani",
  "gisada",
  "gissah",
  "givenchy",
  "glossier",
  "goldfield banks",
  "gritti",
  "grossmith",
  "gucci",
  "guerlain",
  "guess",
  "gulf orchid",
  "guy laroche",
  "halloween",
  "halston",
  "heeley",
  "henry rose",
  "heretic parfum",
  "hermes",
  "houbigant",
  "house of dreams",
  "house of oud",
  "house of sillage",
  "hugo boss",
  "imaginary authors",
  "influxious",
  "initio parfums prives",
  "insider parfums",
  "issey miyake",
  "jacomo",
  "janan",
  "jean paul gaultier",
  "jennifer lopez",
  "jeremy fragrance",
  "jimmy choo",
  "jo malone london",
  "jo milano",
  "jo milano paris",
  "john varvatos",
  "joop",
  "jorum studio",
  "jovan",
  "jovoy paris",
  "juicy couture",
  "juliette has a gun",
  "jusbox",
  "kajal",
  "kate spade",
  "katy perry",
  "kayali",
  "kenneth cole",
  "kenzo",
  "kerosene",
  "khadlaj",
  "khloe kardashian",
  "kilian",
  "kilian paris",
  "kim kardashian",
  "kisa",
  "knize",
  "kylie cosmetics",
  "kylie jenner",
  "l artisan parfumeur",
  "l occitane en provence",
  "la falcone",
  "lacoste",
  "lagerfeld",
  "lalique",
  "lancome",
  "lattafa",
  "laura geller",
  "laurent mazzone",
  "le falcone perfumes",
  "le labo",
  "le persona",
  "le sablier",
  "les indemodables",
  "les liquides imaginaires",
  "loewe",
  "lolita lempicka",
  "lorenzo pazzaglia",
  "lorenzo villoresi",
  "louis cardin",
  "louis vuitton",
  "lush",
  "maison alhambra",
  "maison asrar",
  "maison crivelli",
  "maison du roc",
  "maison francis kurkdjian",
  "maison louis marie",
  "maison margiela",
  "majesty",
  "maksim",
  "mancera",
  "marc antoine barrois",
  "marc gebauer",
  "marc jacobs",
  "maryaj",
  "masque milano",
  "matiere premiere",
  "maurer wirtz",
  "megan moroney",
  "megan thee stallion",
  "memo",
  "mennen",
  "mercedes benz",
  "mezmar",
  "michael jordan",
  "michael kors",
  "michael malul",
  "michael malul london",
  "miller harris",
  "mind games",
  "miraclelayer",
  "missoni",
  "miu miu",
  "moncler",
  "montagne",
  "montale",
  "montblanc",
  "moschino",
  "mugler",
  "mykonos",
  "narciso rodriguez",
  "nasomatto",
  "nautica",
  "nest",
  "nicolai",
  "nikos",
  "nikoui",
  "nina ricci",
  "nishane",
  "nusuk",
  "oakcha",
  "ohana kameala",
  "oil perfumery",
  "old spice",
  "olfactive studio",
  "omanluxury",
  "orientica",
  "ormonde jayne",
  "orto parisi",
  "oscar de la renta",
  "paco rabanne",
  "papatui",
  "papillon artisan perfumes",
  "parfum d empire",
  "parfums de marly",
  "paris corner",
  "patek maison",
  "penhaligon s",
  "pepe jeans london",
  "pernoire",
  "perry ellis",
  "philosophy",
  "phlur",
  "pierre cardin",
  "pinaud",
  "pino silvestre",
  "prada",
  "precious liquid",
  "prescriptives",
  "prin",
  "quorum",
  "ralph lauren",
  "rare beauty",
  "rasasi",
  "rayhaan",
  "regalien",
  "reyane tradition",
  "rihanna",
  "riiffs",
  "robert piguet",
  "roberto cavalli",
  "rochas",
  "roja parfums",
  "room 1015",
  "rue broca",
  "ryziger parfums",
  "salvatore ferragamo",
  "santa maria novella",
  "sapil",
  "sarah baker",
  "sarah jessica parker",
  "sboy",
  "serge lutens",
  "shiseido",
  "simone andreoli",
  "skylar",
  "slumberhouse",
  "snif",
  "sol de janeiro",
  "sospiro",
  "speick",
  "statik olfactive",
  "stephane humbert lucas 777",
  "stetson",
  "street origins",
  "superz budapest",
  "swiss arabian",
  "tabac",
  "tauer perfumes",
  "taylor of old bond street",
  "taylor swift",
  "territoire",
  "thameen",
  "the 7 virtues",
  "the body shop",
  "the different company",
  "the spirit of dubai",
  "the street scent",
  "thomas kosmala",
  "tiziana terenzi",
  "tocca",
  "tom ford",
  "tommy bahama",
  "tommy hilfiger",
  "tonino lamborghini",
  "top shelf fragrances",
  "toskovat",
  "trish mc evoy",
  "trudon",
  "truefitt hill",
  "tumi",
  "v siteur",
  "valentino",
  "van cleef arpels",
  "velixir",
  "vera wang",
  "versace",
  "vertus",
  "victoria s secret",
  "viktor rolf",
  "vilhelm parfumerie",
  "vivamor",
  "vivamor parfums",
  "vyrao",
  "welton london",
  "xeena",
  "xerjoff",
  "yves saint laurent",
  "zadig voltaire",
  "zaharoff",
  "zara",
  "zimaya",
  "zoologist",
  "zoologist perfumes"
])
